
import Vue from 'vue';

export default Vue.extend({
  props: {
    caption: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  computed: {
    styleImage() {
      return this.image
        ? {
            'background-image': `linear-gradient(to bottom, rgba(0, 0, 0, 0.1) 34%, #000000 91%), url(${this.image})`,
          }
        : {
            'background-image': `linear-gradient(to bottom, rgba(0, 0, 0, 0.1) 34%, #000000 91%)`,
          };
    },
  },
});
